import moment from 'moment-timezone'
import { localStore } from '@/_utils/localstore'
import { DEFAULT_LOCALE } from '@/_consts/common'

const formatDatetime = 'YYYY/MM/DD H:m:s'
const lang = localStore.getItem('lang') || DEFAULT_LOCALE
const epochs = [
  [lang === DEFAULT_LOCALE ? '年前' : ' year', 31536000],
  [lang === DEFAULT_LOCALE ? 'ヶ月前' : ' month', 2592000],
  [lang === DEFAULT_LOCALE ? '日前' : ' day', 86400],
  [lang === DEFAULT_LOCALE ? '時間前' : ' hour', 3600],
  [lang === DEFAULT_LOCALE ? '分前' : ' minute', 60],
  [lang === DEFAULT_LOCALE ? '秒前' : ' second', 1],
]

export const DatetimeUtils = {
  now: () => {
    return moment().format()
  },

  nowEnd: () => {
    const now = moment().toDate()
    now.setHours(23)
    now.setMinutes(59)
    now.setSeconds(59)

    return moment(now).format()
  },

  last7Days: () => {
    const last7days = moment()
      .subtract(1, 'weeks')
      .toDate()
    last7days.setHours(0)
    last7days.setMinutes(0)
    last7days.setSeconds(0)

    return moment(last7days).format()
  },

  getTime: (dateOrTime: any) => {
    return new Date(dateOrTime).getTime()
  },

  getDatetimeFormat: () => {
    return formatDatetime
  },
}

// Get duration
const getDuration = timeAgoInSeconds => {
  for (const epoch of epochs) {
    const name = epoch[0]
    const seconds = epoch[1] as number

    const interval = Math.floor(timeAgoInSeconds / seconds)

    if (interval >= 1) {
      return {
        interval,
        epoch: name,
      }
    }
  }
}

export const localeData = () => {
  if (lang !== DEFAULT_LOCALE) {
    return {
      direction: 'ltr',
      format: formatDatetime,
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      weekLabel: 'W',
      customRangeLabel: 'Custom Range',
      daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      firstDay: 0,
    }
  }

  return {
    direction: 'ltr',
    format: formatDatetime,
    separator: ' - ',
    applyLabel: '適用',
    cancelLabel: 'キャンセル',
    weekLabel: 'W',
    customRangeLabel: 'カスタム範囲',
    daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
    monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    firstDay: 0,
    localeRanges: {
      today: '今日',
      yesterday: '昨日',
      last1Week: '1週間前',
      thisMonth: '今月',
      lastMonth: '先月',
      thisYear: '今年',
    },
  }
}

export const timeAgo = (datetime, useSuffix = false) => {
  const datetimeObj = moment(datetime)
  const now = moment.utc(new Date())
  // Minimum diff is 1 second
  const timeAgoInSeconds = now.diff(datetimeObj, 'seconds') || (datetime ? 1 : 0)
  const du = getDuration(timeAgoInSeconds)
  if (du) {
    const interval = du.interval
    const epoch = du.epoch
    let suffix
    if (lang === DEFAULT_LOCALE) {
      suffix = ''
    } else {
      suffix = interval === 1 ? '' : 's'
    }

    return `${interval}${epoch}${suffix}${useSuffix && lang === 'en' ? ' ago' : ''}`
  }
}

export const unitTimezone = () => {
  const user = JSON.parse(localStore.getItem('user') as string)

  if (!user) {
    return
  }

  return user.timezone
}

export const parserTimeByFormat = (date: string | Date, format: string = 'YYYY-MM-DD HH:mm:ss') => {
  return moment(date).format(format)
}

export const parserTimeToUnixAgo = (date: string | Date) => {
  const unixTime = moment(date).unix()
  return moment.unix(unixTime).fromNow()
}

export const convertSecondsToTime = (time: number) => {
  const h = Math.floor(time / 3600)
  const m = Math.floor((time % 3600) / 60)
  const s = Math.floor((time % 3600) % 60)

  const hDisplay = h > 0 ? h + (h === 1 ? ' hour, ' : ' hours, ') : ''
  const mDisplay = m > 0 ? m + (m === 1 ? ' minute, ' : ' minutes, ') : ''
  const sDisplay = s > 0 ? s + (s === 1 ? ' second' : ' seconds') : ''
  return hDisplay + mDisplay + sDisplay
}

export const getDatetimeFormat = () => {
  return formatDatetime
}

export const getDateTime = (date: string) => {
  return new Date(date).getTime()
}
